import { colors } from "#app/theme/v2/colors";
import { radius } from "#app/theme/v2/radius";
import { shadows } from "#app/theme/v2/shadows";
import { spacing } from "#app/theme/v2/spacing";
import { Text } from "#components/atoms/Typographies/Text";
import { Icon } from "#shared/icons/Icon";

import classes from "./Hint.module.css";

type HintProps = {
  title: string;
  description: string;
  closeLabel: string;
  onClose: () => void;
};

const Hint = ({ title, description, closeLabel, onClose }: HintProps) => (
  <div
    className={classes.hint}
    role="note"
    style={
      {
        "--hint-padding": spacing[2],
        "--hint-radius": radius.md,
        "--hint-bg": colors.bg.elevation.tooltip,
        "--hint-shadow": shadows.elevation4,
        "--hint-content-gap": spacing[1],
        "--hint-content-padding": `${spacing[1]} ${spacing[2]} ${spacing[2]}`,
        "--hint-close-padding": spacing[2],
        "--hint-close-radius": radius.md,
        "--hint-close-color": colors.icon.primaryInverse,
      } as React.CSSProperties
    }
  >
    <div className={classes.content}>
      <Text size="base" type="medium" color={colors.text.primaryInverse}>
        {title}
      </Text>
      <Text size="small" color={colors.text.secondaryDisabled}>
        {description}
      </Text>
    </div>
    <button type="button" className={classes.close} aria-label={closeLabel} onClick={onClose}>
      <Icon name="x" size={16} color={colors.icon.primaryInverse} />
    </button>
  </div>
);

export { Hint };
